/**
 * @author PengWen
 * @description 岗位兼职信息管理页面配置
 * @Date 2022/11/28
 */

import {component_tool, framework_tool ,utils_tool} from '../../../tool';
import { WizTableForm } from '../../common'
let {WizModal} = component_tool;
let { $$ } = utils_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })

//配置项
let componentName = 'requirementPositionOrder'

const columns = [
    {
        name: "id",
        fromItem: {
          type: "hidden"
        }
    },
    {
        title: "品牌",
        name: "orgName",
        tableItem: {
          width: 200
        },
    },
    {
        title: "品牌",
        name: "orgId",
        searchItem: {
          diy: WizTableForm,
          selectType:"radio",
          ...organizationConfig
        }
    },
    {
        title: "站点类型",
        name: "dealerTypeCh",
        tableItem: {
          width: 400
        },
    },
    {
        title: "站点类型",
        name: "dealerTypeList",
        searchItem: {
            type: 'select',
        },
        dict: [
            { code: 1, codeName: '4S网点' },
            { code: 2, codeName: '直营店' },
            { code: 3, codeName: '单一售后' },
            { code: 4, codeName: '单一销售' },
            { code: 5, codeName: '卫星店/直营店' },
            { code: 6, codeName: '自修站' },
            { code: 7, codeName: '卫星店' },
            { code: 8, codeName: '精品店' },
            { code: 9, codeName: 'dealer' },
            { code: 10, codeName: '4S店' },
            { code: 11, codeName: '汽车零售' },
            { code: 12, codeName: '单一销售展厅' },
            { code: 13, codeName: 'NEV单一售后' },
            { code: 14, codeName: '轻量化4S网点' },
            { code: 15, codeName: 'NEV专区' },
            { code: 16, codeName: '商超店' },
          { code: 17, codeName: '自修店' },
          { code: 18, codeName: '二级网点' },
          { code: 19, codeName: '车工坊C1' },
          { code: 20, codeName: '车工坊C2' },
          { code: 21, codeName: '车工坊B' },
          { code: 22, codeName: '德科品牌授权经销商' },
          { code: 23, codeName: '单一销售展厅(专区)' },
          { code: 24, codeName: '单一销售展厅(商超)' },
            { code: 0, codeName: '无' }
        ],
    },
    {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        searchItem: {
          type: "select",
        },
        dict: [
          {code: 1, codeName: '有效'},
          {code: 0, codeName: '无效'}
        ],
        formItem: {
          initialValue: 1,
          type: 'radio'
        }
    },

];

const templateConfig = {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps:{
          buttonSort: ['add','export'],
          collapse: false,
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderDetailAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update','enableOrDisable','positionSort'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderDetailUpd"
              }
            },
          },
          {
            key: "positionSort",
            custom: true,
            params: { children: "岗位排序"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderInfoList"
              }
            },
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {},//状态  0无效  1有效
            textFormat: {
              recordKey: 'state',
              dirt: {  1: '禁用', 0: '启用' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                  }该岗位排序？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ...record,
                      state: record['state'] === 1 ? 0 : 1,
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
        ],
        rowOperateProps: {
          width: 200,
          fixed: 'right',
        },
        commonOperate: {
          add: true,
          delete: true,
          edit: true
        }
      }
    }
}

const apis = {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    }
}



let reduxTemplateConfig = (args) => {
    return {
      apis,
      componentName,
      initApiKeys: ['list'],
      needLoading: true,
      ...args
    }
};

export {reduxTemplateConfig, templateConfig};
